__turbopack_context__.v({
  "paragraph": "CoreParagraph-module-scss-module__SbwXZq__paragraph",
});
